/**
 * Recomendaciones de producto (relacionados / complementarios) + Swiper.
 */
(function () {
  const toBool = function (v) {
    return String(v) === "true" || String(v) === "1";
  };

  function parseLocaleNumber(v, fallback) {
    if (v == null || v === "") return fallback;
    const n = parseFloat(String(v).trim().replace(",", "."));
    return Number.isFinite(n) ? n : fallback;
  }

  function initPgsSwiperInContainer(container) {
    if (!container || !window.Swiper) return false;
    const el = container.querySelector("[data-pgs-swiper]");
    if (!el) return false;

    if (el.__pgsSwiper) {
      try {
        el.__pgsSwiper.destroy(true, true);
      } catch (e) {}
      el.__pgsSwiper = null;
    }

    const prev = container.querySelector("[data-pgs-prev]");
    const next = container.querySelector("[data-pgs-next]");
    const pagination = container.querySelector("[data-pgs-pagination]");

    const spvM = parseLocaleNumber(el.dataset.spvM, 1);
    const spvT = parseLocaleNumber(el.dataset.spvT, 2);
    const spvD = parseLocaleNumber(el.dataset.spvD, 3);
    const gap = parseLocaleNumber(el.dataset.gap, 16);
    const loop = toBool(el.dataset.loop);
    const autoplayEnabled = toBool(el.dataset.autoplay);
    const speed = Number(el.dataset.speed || 3000);
    const effect = el.dataset.effect || "slide";
    const speedTransition = Number(el.dataset.speedTransition || 300);
    const centered = toBool(el.dataset.centered);
    const grab = toBool(el.dataset.grab);
    const freeMode = toBool(el.dataset.freeMode);
    const pauseOnHover = toBool(el.dataset.pauseOnHover);

    const cfg = {
      slidesPerView: spvM,
      spaceBetween: gap,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      speed: speedTransition,
      effect: effect,
      centeredSlides: centered,
      grabCursor: grab,
      freeMode: freeMode,
      loop: loop,
      breakpoints: {
        768: { slidesPerView: spvT, centeredSlides: centered, spaceBetween: gap },
        1024: { slidesPerView: spvD, centeredSlides: centered, spaceBetween: gap },
      },
    };

    if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
    if (pagination) cfg.pagination = { el: pagination, clickable: true };
    if (autoplayEnabled)
      cfg.autoplay = {
        delay: speed,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
      };

    if (effect === "fade") cfg.fadeEffect = { crossFade: true };
    else if (effect === "cube")
      cfg.cubeEffect = {
        shadow: true,
        slideShadows: true,
        shadowOffset: 20,
        shadowScale: 0.94,
      };
    else if (effect === "coverflow")
      cfg.coverflowEffect = {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      };
    else if (effect === "flip")
      cfg.flipEffect = { slideShadows: true, limitRotation: true };

    el.__pgsSwiper = new window.Swiper(el, cfg);

    [50, 200, 500].forEach(function (ms) {
      setTimeout(function () {
        if (el.__pgsSwiper) el.__pgsSwiper.update();
      }, ms);
    });

    return true;
  }

  window.twInitPgsSwiper = initPgsSwiperInContainer;

  function parseRecommendationsFromHtml(html, anchorId) {
    try {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const roots = [doc, doc.querySelector(".shopify-section")].filter(Boolean);
      let rec = null;
      for (let i = 0; i < roots.length && !rec; i++) {
        const root = roots[i];
        if (anchorId) {
          rec = root.querySelector(
            'tw-product-recommendations[data-rec-anchor="' + String(anchorId).replace(/"/g, "") + '"]'
          );
        }
        if (!rec) rec = root.querySelector("tw-product-recommendations");
      }
      return rec;
    } catch (e) {
      return null;
    }
  }

  function recommendationsHasProductCards(recEl) {
    if (!recEl) return false;
    return !!(recEl.querySelector(".tw-pc") || recEl.querySelector("article.tw-pc"));
  }

  function bootRelatedRoots() {
    document.querySelectorAll(".product-grid-simple--related").forEach(function (root) {
      const el = root.querySelector("[data-pgs-swiper]");
      if (!el) return;
      let tries = 0;
      const t = setInterval(function () {
        tries++;
        if (initPgsSwiperInContainer(root) || tries > 40) clearInterval(t);
      }, 100);
    });
  }

  function bootPdpComplementaryCarousels() {
    document.querySelectorAll("tw-product-recommendations[data-rec-anchor]").forEach(function (host) {
      if (!host.querySelector("[data-pgs-swiper]")) return;
      let tries = 0;
      const t = setInterval(function () {
        tries++;
        if (initPgsSwiperInContainer(host) || tries > 40) clearInterval(t);
      }, 100);
    });
  }

  if (!window.customElements || !window.customElements.get("tw-product-recommendations")) {
    class TwProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this._observed) return;
        this._observed = true;
        const url = this.getAttribute("data-url");
        if (!url) return;
        const anchorId = this.getAttribute("data-rec-anchor") || "";

        const applyResponse = function (html) {
          const rec = parseRecommendationsFromHtml(html, anchorId || null);
          const compRoot = this.closest(".tw-pdp-complementary");
          const isPdpComplementary = !!this.getAttribute("data-rec-anchor");

          if (!rec) {
            console.warn("Product recommendations: could not parse section response");
            if (isPdpComplementary && compRoot) compRoot.hidden = true;
            return;
          }

          const hasCards = recommendationsHasProductCards(rec);
          const innerTrim = rec.innerHTML.trim();
          if (hasCards || innerTrim) {
            this.innerHTML = rec.innerHTML;
            if (compRoot) compRoot.hidden = false;
            if (this.querySelector("[data-pgs-swiper]")) {
              let tries = 0;
              const timer = setInterval(
                function () {
                  tries++;
                  if (initPgsSwiperInContainer(this) || tries > 50) clearInterval(timer);
                }.bind(this),
                100
              );
            }
          } else if (isPdpComplementary) {
            this.innerHTML = "";
            if (compRoot) compRoot.hidden = true;
          }
        }.bind(this);

        const runFetch = function () {
          fetch(url)
            .then(function (r) {
              if (!r.ok) throw new Error("HTTP " + r.status);
              return r.text();
            })
            .then(applyResponse)
            .catch(
              function (e) {
                console.error("Product recommendations:", e);
                if (this.getAttribute("data-rec-anchor")) {
                  const root = this.closest(".tw-pdp-complementary");
                  if (root) root.hidden = true;
                }
              }.bind(this)
            );
        }.bind(this);

        if (window.Shopify && window.Shopify.designMode) {
          runFetch();
          return;
        }

        const observer = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            runFetch();
          }.bind(this),
          { rootMargin: "0px 0px 400px 0px" }
        );
        observer.observe(this);
      }
    }
    window.customElements.define("tw-product-recommendations", TwProductRecommendations);
  }

  function onReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    bootRelatedRoots();
    bootPdpComplementaryCarousels();
  });

  function refreshSwipersForSectionId(sectionId) {
    const relatedRoot = document.querySelector(
      ".product-grid-simple-" + sectionId + ".product-grid-simple--related"
    );
    if (relatedRoot) setTimeout(function () {
      initPgsSwiperInContainer(relatedRoot);
    }, 150);
    const anySection = document.querySelector('section[data-section-id="' + sectionId + '"]');
    if (anySection) {
      anySection.querySelectorAll("tw-product-recommendations[data-rec-anchor]").forEach(function (host) {
        if (!host.querySelector("[data-pgs-swiper]")) return;
        setTimeout(function () {
          initPgsSwiperInContainer(host);
        }, 150);
      });
    }
  }

  document.addEventListener("shopify:section:load", function (e) {
    refreshSwipersForSectionId(e.detail.sectionId);
  });
  document.addEventListener("shopify:section:select", function (e) {
    refreshSwipersForSectionId(e.detail.sectionId);
  });
})();
